import React from 'react';

function RealTimeIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_570_2388)">
                <rect width="24" height="24" rx="12" fill="white" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21 0C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3C0 1.34315 1.34315 0 3 0H21ZM12.75 4.5C12.525 4.5 12.33 4.6035 12.192 4.7595L6.2235 12.2175C6.219 12.222 6.1695 12.285 6.1695 12.285C6.0705 12.4185 6 12.573 6 12.75C6 13.164 6.336 13.5 6.75 13.5C6.792 13.5 6.8265 13.5075 6.8655 13.5H10.5V18.75C10.5 19.164 10.836 19.5 11.25 19.5C11.436 19.5 11.601 19.425 11.7315 19.314C11.7315 19.314 11.8245 19.2135 11.859 19.164L17.76 11.7945C17.7885 11.7675 17.8065 11.736 17.8305 11.7045L17.871 11.655C17.9445 11.5335 18 11.4 18 11.25C18 10.836 17.664 10.5 17.25 10.5H13.5V5.25C13.5 4.836 13.164 4.5 12.75 4.5Z"
                    fill="#FBB414"
                />
            </g>
            <defs>
                <clipPath id="clip0_570_2388">
                    <rect width="24" height="24" rx="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default RealTimeIcon;
